import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'daas-consulting-shared-layout-empty-state2',
  standalone: true,
  imports: [CommonModule, EmptyStateComponent],
  templateUrl: './empty-state2.component.html',
  styleUrl: './empty-state2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyState2Component {
  @Input() showAdjustFilters = true;

  animate$: Observable<boolean>;
  #animate$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.animate$ = this.#animate$.asObservable();
  }

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent) {
    event.stopImmediatePropagation();
    event.preventDefault();
    this.#animate$.next(true);
    setTimeout(() => {
      this.#animate$.next(false);
    }, 150);
  }
}
